import { Component } from '@angular/core';

@Component({
  selector: 'lib-feature-erp-data-access',
  imports: [],
  templateUrl: './feature-erp-data-access.html',
  styleUrl: './feature-erp-data-access.css',
})
export class FeatureErpDataAccess {}
